import { getBorderRadius as getGlobalBorderRadius } from './global';
export function getBorderRadius(transformer) {
    const globalBorderRadius = getGlobalBorderRadius(transformer);
    return Object.freeze({
        containerWithBackgroundColor: { value: globalBorderRadius.small },
        containerWithBorder: { value: globalBorderRadius.small },
        containerWithShadow: { value: globalBorderRadius.small },
        containerDragAndDrop: { value: globalBorderRadius.small },
        button: { value: globalBorderRadius.small },
        circle: { value: globalBorderRadius.fiftyPercent },
        bottomSheet: {
            container: { value: globalBorderRadius.medium },
            slideButton: { value: globalBorderRadius.medium },
        },
        progressIndicator: {
            track: { value: globalBorderRadius.medium },
        },
        form: {
            input: { value: globalBorderRadius.small },
            switch: { value: globalBorderRadius.medium },
            radioButton: { value: globalBorderRadius.fiftyPercent },
        },
        modal: { value: globalBorderRadius.small },
        menuItem: { value: globalBorderRadius.small },
    });
}
